const OAUTH_ATTEMPT_KEY = 'paper-wx-oauth-attempt'
const BASE_URL = process.env.VUE_APP_BASE_API || '/prod-api'

export function isWechatBrowser() {
  return typeof navigator !== 'undefined' && /MicroMessenger/i.test(navigator.userAgent || '')
}

export function isWechatOauthPublicRoute(path) {
  return ['/terms', '/privacy', '/wechat-auth'].includes(path)
}

export function getWechatOauthAttempt() {
  try {
    return JSON.parse(window.sessionStorage.getItem(OAUTH_ATTEMPT_KEY) || 'null')
  } catch (error) {
    return null
  }
}

export function clearWechatOauthAttempt() {
  window.sessionStorage.removeItem(OAUTH_ATTEMPT_KEY)
}

export function startWechatOauth(target, force = false) {
  if (!isWechatBrowser()) return false
  if (!force && getWechatOauthAttempt()) return false

  const safeTarget = typeof target === 'string' && target.startsWith('/') ? target : '/'
  window.sessionStorage.setItem(OAUTH_ATTEMPT_KEY, JSON.stringify({ target: safeTarget, time: Date.now() }))
  const query = new URLSearchParams({ target: safeTarget })
  window.location.replace(`${BASE_URL}/wxPcLogin/oauth/authorize?${query.toString()}`)
  return true
}
